import {
  getPublishedPage as publicGetPublishedPage,
  getPublishedPageBySlug as publicGetPublishedPageBySlug,
  getPublishedPageByPageId as publicGetPublishedPageByPageId,
  queryPublishedPages as publicQueryPublishedPages,
  typedQueryPublishedPages as publicTypedQueryPublishedPages,
} from './quickpages-v1-published-page-published-pages.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  PublishedPageQuery,
  PublishedPagesQueryBuilder,
  typedQueryPublishedPages as universalTypedQueryPublishedPages,
} from './quickpages-v1-published-page-published-pages.universal.js';

function customQueryPublishedPages(httpClient: HttpClient) {
  const router = createQueryOverloadRouter({
    builderQueryFunction: () => publicQueryPublishedPages(httpClient)(),
    typedQueryFunction: (query: PublishedPageQuery) =>
      publicTypedQueryPublishedPages(httpClient)(query),
    hasOptionsParameter: false,
  });

  function overloadedQuery(): PublishedPagesQueryBuilder;
  function overloadedQuery(
    query: PublishedPageQuery
  ): ReturnType<typeof universalTypedQueryPublishedPages>;
  function overloadedQuery(query?: PublishedPageQuery): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

/** @internal */
export const getPublishedPage: MaybeContext<
  BuildRESTFunction<typeof publicGetPublishedPage> &
    typeof publicGetPublishedPage
> = /*#__PURE__*/ createRESTModule(publicGetPublishedPage);
/** @internal */
export const getPublishedPageBySlug: MaybeContext<
  BuildRESTFunction<typeof publicGetPublishedPageBySlug> &
    typeof publicGetPublishedPageBySlug
> = /*#__PURE__*/ createRESTModule(publicGetPublishedPageBySlug);
/** @internal */
export const getPublishedPageByPageId: MaybeContext<
  BuildRESTFunction<typeof publicGetPublishedPageByPageId> &
    typeof publicGetPublishedPageByPageId
> = /*#__PURE__*/ createRESTModule(publicGetPublishedPageByPageId);
export const queryPublishedPages: MaybeContext<
  BuildRESTFunction<typeof customQueryPublishedPages> &
    typeof customQueryPublishedPages
> = /*#__PURE__*/ createRESTModule(customQueryPublishedPages);

export {
  SortOrder,
  WebhookIdentityType,
} from './quickpages-v1-published-page-published-pages.universal.js';
export {
  PublishedPage,
  GetPublishedPageRequest,
  GetPublishedPageResponse,
  GetPublishedPageBySlugRequest,
  GetPublishedPageBySlugResponse,
  GetPublishedPageByPageIdRequest,
  GetPublishedPageByPageIdResponse,
  QueryPublishedPagesRequest,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Sorting,
  CursorPaging,
  QueryPublishedPagesResponse,
  CursorPagingMetadata,
  Cursors,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  Empty,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  PublishedPagesQueryResult,
  PublishedPagesQueryBuilder,
  PublishedPageQuerySpec,
} from './quickpages-v1-published-page-published-pages.universal.js';
export { utils } from './quickpages-v1-published-page-published-pages.universal.js';
export {
  SortOrderWithLiterals,
  WebhookIdentityTypeWithLiterals,
  CommonQueryWithEntityContext,
  PublishedPageQuery,
} from './quickpages-v1-published-page-published-pages.universal.js';
